/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';
    var app = angular.module('enervee');

    /*
     Creates checkout cart item markup
     <cart-item data-cart-item="cartItem"></cart-item>
     */

    app.directive('cartItem', [
        function () {
            return {
                restrict: 'E',
                replace: true,
                scope: {
                    cartItem: '=',
                    isLocked: '<'
                },
                controller: [
                    '$log',
                    '$filter',
                    '$scope',
                    '$timeout',
                    'CartService',
                    'CartAnalyticsService',
                    'EnerveeCheckoutService',
                    'UtilService',
                    function (
                        $log,
                        $filter,
                        $scope,
                        $timeout,
                        CartService,
                        CartAnalyticsService,
                        EnerveeCheckoutService,
                        UtilService
                    ) {

                        var isCheckoutEnabled = UtilService.isFeatureEnabled('checkout_enabled');

                        $scope.canChangeQuantity = true;
                        $scope.cartItemContext = {};

                        /**
                         * Watch and update the cartItemContext so cms-content displays an accurate rebate amount
                         */
                        $scope.$watchGroup(['cartItem.rebate_amount', 'cartItem.rebate_quantity'], function () {
                            $scope.cartItemContext.rebateAmount = $filter('currency')($scope.cartItem.rebate_amount * $scope.cartItem.rebate_quantity);
                        });

                        /**
                         * Helper function to update the quantity of this product (for checkout)
                         *
                         * @param {Number} amount
                         * @return {Promise} resolves upon successfully updating
                         * the CAPI cart
                         */
                        function checkoutUpdateQuantity(amount) {
                            $scope.canChangeQuantity = false;
                            return EnerveeCheckoutService.addProductToCart($scope.cartItem.id, amount).then(function success() {
                                var typeOfChange = 'Add Product';
                                if (amount < 0) {
                                    typeOfChange = 'Remove Product';
                                }
                                CartAnalyticsService.reportEvent('Cart Engaged', {
                                    location: 'cart',
                                    type_of_change: typeOfChange,
                                });
                            }, function error(error) {
                                $log.warn('Enervee Checkout Error: ' + error);
                            }).finally(function() {
                                $scope.canChangeQuantity = true;
                            });
                        }

                        /**
                         * Decreases the quantity of the cartItem by one.
                         * If the resulting quantity is 0, then the cartItem is hidden (and removed
                         * eventually)
                         */
                        $scope.decrementQuantity = function () {
                            if (isCheckoutEnabled) {
                                checkoutUpdateQuantity(-1);
                            }
                        };

                        /**
                         * Increases the quantity of the cartItem by one.
                         */
                        $scope.incrementQuantity = function () {
                            if (isCheckoutEnabled) {
                                checkoutUpdateQuantity(1);
                            }
                        };
                    }
                ],
                template: require('@app/shared/cart/cartItemView.html'),
            };
        }
    ]);
})(angular);
